import { findPrice } from '../prices';

export const filterProductsByPrice = (products: Array<GQL.IProduct>, priceFilters: Array<{ value: string }>) => {
    if (!Array.isArray(priceFilters) || priceFilters.length == 0) {
        return products;
    }

    const filteredProducts = new Array<GQL.IProduct>();

    for (const product of products) {
        for (const priceFilter of priceFilters) {
            const index = parseInt(priceFilter.value);
            const min = index * 500;
            const max = index * 500 + 500;

            const price = findPrice(product.prices, false, null, product);
            if (price) {
                if (price >= min && price <= max) {
                    filteredProducts.push(product);
                }
            }
        }
    }

    return filteredProducts;
};



// WEBPACK FOOTER //
// ./src/helpers/products/filterProductsByPrice.ts